var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"Gender","items":[{text: 'Male',value: _vm.api.CONSTANTS.GENDER.MALE},{text: 'Female',value: _vm.api.CONSTANTS.GENDER.FEMALE}],"rules":_vm.rules,"append-icon":"fa fa-venus-mars"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }